<template>
<a href="###" :class="current" :data-scp="scp">
	<i class="icon icon-shiyijian"></i><span>试衣间</span>
</a>
</template>

<script>
export default {
	props: ['scp', 'current']
};
</script>